import { createContext } from 'react'

export type NavigationPanelContextType = {
  isOpen: boolean
  open: () => void
  close: () => void
  toggle: () => void
}

const NavigationPanelContext = createContext<NavigationPanelContextType | undefined>(undefined);

export { NavigationPanelContext }



